import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { environment } from '../../../environments/environment';
import { UserService } from '../services/user.service';
import { AppSettings } from '../app-settings/app-settings';

export interface TranslationModel {
  [sectionKey: string]: {
    [key: string]: string;
  };
}

@Injectable()
export class RxHttpLoader implements TranslateLoader {
  private httpLoader: Observable<TranslateHttpLoader>;
  private settings: AppSettings;

  constructor(
    private http: HttpClient,
    private appSettingsService: AppSettingsService,
    private userService: UserService,
  ) {
    appSettingsService.Settings.subscribe((v) => {
      this.settings = v;
    });
  }

  getTranslation2(lang: string): Observable<any> {
    return this.httpLoader.pipe(mergeMap(v => v.getTranslation(lang)));
  }

  getTranslation(lang: string): Observable<TranslationModel> {
    return new Observable((observer) => {
      const tag = 'translate_' + this.appSettingsService.affiliateId;
      const transLocal = sessionStorage.getItem(tag);
      if (transLocal) {
        observer.next(JSON.parse(transLocal) as TranslationModel);
        return;
      }

      let url = `${environment.apiBaseURL}/affiliates/${this.appSettingsService.affiliateId}/translations`;

      if (this.userService.OrganizerId > 0) {
        url = `${url}?organizerId=${this.userService.OrganizerId}`;
      }

      this.http.get(url).subscribe((data: TranslationModel) => {
        this.setTranslationToLocalSession(data);
        observer.next(data);
      });
    });
  }

  public setTranslationToLocalSession(data: TranslationModel): void {
    const tag = 'translate_' + this.appSettingsService.affiliateId;

    sessionStorage.setItem(tag, JSON.stringify(data));
  }
}
